import { apiPostAuth, apiPutAuth, apiGetAuth } from '@/utils/api'
import { API_EMPLOYEE, API_PROGRAM_SETTING } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

// Token anti-race LPD karyawan: tiap fetch saldo program menulis SATU slot
// `employee_lpd_program`. Saat ganti tab cepat / banyak tab mount serentak,
// respons program lama bisa datang belakangan & menimpa tab aktif. Hanya respons
// dari request TERAKHIR yang di-commit. (Detail.vue juga fetch hanya tab aktif.)
let lpdRequestToken = 0

const state = {
  employee_list: {
    isLoading: false,
    data: {}
  },
  detail_employee: {
    isLoading: false,
    data: {}
  },
  employee_lpd_program: {
    isLoading: false,
    data: {}
  },
  program_setting_list: { data: [] },
  detail_employee_token: {},
  data_modal_add_edit: {},
  employee_setting: {
    email: true,
    ktp_file: '',
    npwp_file: '',
    employee_program: []
  },
  employee_extra_program_setting: {},
  is_domicile: true,
  detail_modal_preview: {},
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  },
  meta_filter_pml: {
    total_program_inactive: '1',
    order_by: 'updated_at', 
    sort_by: 'desc'
  },
  modal_info: {
    isOpen: false,
    title: 'Informasi',
    description: 'Mohon lengkapi data pribadi Anda (NIK, Nama Lengkap, Tanggal Lahir, Jenis Kelamin, dan Nama Ibu Kandung) untuk dapat melihat e‑Sertifikat Anda. Pastikan seluruh data yang diisi akurat dan sesuai dengan dokumen resmi',
    buttonTitle: 'Mengerti'
  },
  toggle_modal_add_edit_discard: {
    targetModals: false,
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false,
    modalSummary: false
  }
}

const mutations = {
  "SET_EMPLOYEE_LIST": (state, payload) => {
    state.employee_list = payload
  },
  "SET_PROGRAM_SETTING_LIST": (state, payload) => {
    state.program_setting_list = payload
  },
  "SET_DETAIL_EMPLOYEE": (state, payload) => {
    state.detail_employee = payload
  },
  "SET_EMPLOYEE_LPD_PROGRAM": (state, payload) => {
    state.employee_lpd_program = payload
  },
  "SET_DETAIL_EMPLOYEE_TOKEN": (state, payload) => {
    state.detail_employee_token = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_EMPLOYEE_SETTING": (state, payload) => {
    state.employee_setting = payload
  },
  "SET_EMPLOYEE_EXTRA_PROGRAM_SETTING": (state, payload) => {
    state.employee_extra_program_setting = payload
  },
  "SET_IS_DOMICILE": (state, payload) => {
    state.is_domicile = payload
  },
  "SET_DETAIL_MODAL_PREVIEW": (state, payload) => {
    state.detail_modal_preview = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  },
  "SET_META_FILTER_PML": (state, payload) => {
    state.meta_filter_pml = payload
  },
  "SET_MODAL_INFO": (state, payload) => {
    state.modal_info = payload
  }
}

const actions = {
  async getEmployeeList(context, payload) {
    const { signal, ...params } = payload || {}
    try {
      context.commit('SET_EMPLOYEE_LIST', { isLoading: true })
      const response = await apiGetAuth(API_EMPLOYEE.LIST, params, signal)
      context.commit('SET_EMPLOYEE_LIST', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      if (err?.name === 'AbortError' || err?.name === 'CanceledError' || err?.code === 'ERR_CANCELED') return
      context.commit('SET_EMPLOYEE_LIST', {
        isLoading: false,
        data: {}
      })
      notificationDanger(err)
    }
  },
  async getProgramSettingList(context, payload) {
    try {
      const response = await apiGetAuth(API_PROGRAM_SETTING.LIST, payload)
      context.commit('SET_PROGRAM_SETTING_LIST', response.data)
    } catch (err) {
      notificationDanger(err)
    }
  },
  async getDetailEmployee(context, payload) {
    try {
      context.commit('SET_DETAIL_EMPLOYEE', {
        isLoading: true,
        data: false
      })
      const response = await apiGetAuth(API_EMPLOYEE.BY_ID(payload))
      context.commit('SET_DETAIL_EMPLOYEE', {
        isLoading: false,
        data: response.data?.data
      })
    } catch (error) {
      context.commit('SET_DETAIL_EMPLOYEE', {
        isLoading: false,
        data: false
      })
      notificationDanger(error)
    }
  },
  async getDetailEmployeeToken(context) {
    try {
      const response = await apiGetAuth(API_EMPLOYEE.BY_TOKEN)
      context.commit('SET_DETAIL_EMPLOYEE_TOKEN', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getEmployeeBalanceProgram(context, payload) {
    const token = ++lpdRequestToken
    context.commit('SET_EMPLOYEE_LPD_PROGRAM', { isLoading: true })
    try {
      const response = await apiGetAuth(API_EMPLOYEE.EMPLOYEE_BALANCE_REPORT(payload?.id), payload?.params)
      if (token !== lpdRequestToken) return // respons basi, jangan timpa tab aktif
      context.commit('SET_EMPLOYEE_LPD_PROGRAM', {
        isLoading: false,
        data: response?.data
      })
    } catch (error) {
      if (token !== lpdRequestToken) return
      notificationDanger(error)
      context.commit('SET_EMPLOYEE_LPD_PROGRAM', {
        isLoading: false,
        data: {}
      })
    }
  },
  async createEmployee(context, payload) {
    try {
      const response = await apiPostAuth(API_EMPLOYEE.CREATE_EMPLOYEE, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateEmployee(context, payload) {
    try {
      const response = await apiPutAuth(API_EMPLOYEE.BY_ID(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      throw error
    }
  },
  async updateEmployeeToken(context, payload) {
    try {
      const response = await apiPutAuth(API_EMPLOYEE.BY_TOKEN, payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async employeeUpdateProgram(context, payload) {
    try {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', { isLoading: true })
      const response = await apiPostAuth(API_EMPLOYEE.ADD_PROGRAM_EMPLOYEE, payload)
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', { isLoading: false })
      return response?.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false,
        isLoading: false
      })
      throw error
    }
  },
  async employeeOnboardingPml(context, payload) {
    // Backend enqueue job async (validasi sinkron, aktivasi di worker) → response cepat.
    // Timeout 30s jaga-jaga; error dilempar ke caller supaya page bisa tampilkan pesan,
    // bukan ditelan lalu modal tutup diam-diam.
    const response = await apiPostAuth(API_EMPLOYEE.EMPLOYEE_ONBOARDING_PML, payload, 30000)
    return response.data
  },
  async employeeBackPayDeposit(context, payload) {
    try {
      const response = await apiPostAuth(API_EMPLOYEE.EMPLOYEE_BACK_PAY, payload)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  // Rapel Pembayaran Iuran — ajukan rapel peserta FREEZE. Throw agar pesan BE
  // (mis. 409 sudah ada pengajuan aktif) tampil di catch pemanggil.
  // reqBody memuat salary_basis ('OLD'|'NEW') bila peserta punya perubahan gaji
  // selama Freeze; BE menolak pengajuan tanpa pilihan pada kasus itu.
  async submitRapel(context, payload) {
    const response = await apiPostAuth(API_EMPLOYEE.EMPLOYEE_RAPEL(payload.id), payload?.reqBody || {})
    return response?.data
  },
  // Cek perubahan gaji selama Freeze sebelum modal rapel dibuka. Throw agar
  // pemanggil bisa membatalkan pembukaan modal saat pengecekan gagal.
  async getRapelSalaryOptions(context, payload) {
    const response = await apiGetAuth(API_EMPLOYEE.EMPLOYEE_RAPEL_SALARY_OPTIONS(payload.id))
    return response?.data?.data
  },
  async employeeAccessUpdate(context, payload) {
    try {
      const response = await apiPutAuth(API_EMPLOYEE.UPDATE_EMPLOYEE_ACCESS(payload.id), payload?.reqBody)
      return response?.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      throw error
    }
  },
  async employeeAccessUpdateBulk(context, payload) {
    try {
      const response = await apiPostAuth(API_EMPLOYEE.UPDATE_EMPLOYEE_ACCESS_BULK, payload)
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  },
  async regenerateECertificate(context, employeeId) {
    try {
      const response = await apiPostAuth(API_EMPLOYEE.REGENERATE_E_CERTIFICATE(employeeId))
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  }
}

const getters = {
  get_employee_list: state => {
    return state.employee_list
  },
  get_program_setting_list: state => {
    return state.program_setting_list
  },
  get_detail_employee: state => {
    return state.detail_employee
  },
  get_employee_lpd_program: state => {
    return state.employee_lpd_program
  },
  get_detail_employee_token: state => {
    return state.detail_employee_token
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  get_employee_setting: state => {
    return state.employee_setting
  },
  get_employee_extra_program_setting: state => {
    return state.employee_extra_program_setting
  },
  get_is_domicile: state => {
    return state.is_domicile
  },
  get_detail_modal_preview: state => {
    return state.detail_modal_preview
  },
  meta_filter: state => {
    return state.meta_filter
  },
  meta_filter_pml: state => {
    return state.meta_filter_pml
  },
  get_modal_info: state => {
    return state.modal_info
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
